var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupsStatsSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-146.637%",
    x2: "50%",
    y2: "115.238%",
    id: "it4f74hj8b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77AADB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182F77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-18.348%",
    x2: "50%",
    y2: "200.904%",
    id: "sd3xnhqqwe"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77AADB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182F77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.001%",
    y1: "-146.634%",
    x2: "50.001%",
    y2: "115.242%",
    id: "c2ndwfq1oh"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77AADB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182F77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.999%",
    y1: "-18.226%",
    x2: "49.999%",
    y2: "201.035%",
    id: "xqgrhll8ak"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77AADB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182F77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-127.455%",
    x2: "50%",
    y2: "97.013%",
    id: "1afkcah0xn"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77AADB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182F77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-2.86%",
    x2: "50%",
    y2: "187.141%",
    id: "j964643ztq"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77AADB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182F77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.524.804C.314 2.05.054 4.51 0 6.503h2.87v-.051c.2-2.823.83-4.75 1.926-5.89.04-.042.083-.083.128-.121A2.905 2.905 0 0 1 3.741 0c-.636.015-1.75.317-2.217.804",
    id: "5362jmud2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.055 2.401c-.063.346-.174 1.308.346 3.29v.001a2.77 2.77 0 0 0 1.025 1.53 2.74 2.74 0 0 0 1.753.543 2.963 2.963 0 0 0 1.525-.4 3.98 3.98 0 0 1-.968-1.753c-.457-1.715-.61-3.162-.428-4.15.093-.493.285-.96.564-1.377A3.28 3.28 0 0 0 3.179 0C1.694 0 .305 1.04.055 2.401",
    id: "lhvim7p7ld"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18 0A2.89 2.89 0 0 1 0 .44c.039.035.075.072.111.108C1.215 1.685 1.85 3.617 2.05 6.452v.051h2.872c-.053-2-.33-4.47-1.537-5.711C2.921.304 1.813.015 1.181 0z",
    id: "zem3ejf29g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52 0c-.23 0-.46.026-.685.075.281.422.473.897.564 1.396.181.989.038 2.436-.414 4.14A3.982 3.982 0 0 1 0 7.367c.462.268.987.405 1.52.397a2.738 2.738 0 0 0 1.752-.542 2.77 2.77 0 0 0 1.026-1.53c.52-1.983.408-2.945.343-3.29C4.4 1.041 3.01 0 1.525 0H1.52",
    id: "f4xoixcf0j"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.075.558H6.14A3.615 3.615 0 0 1 4.365 0a4.29 4.29 0 0 0-.743.095 5.754 5.754 0 0 0-.745.21 2.951 2.951 0 0 0-1.099.633C.618 2.155.203 4.33.058 6.368.03 6.784.012 7.196 0 7.588h13.212c0-.392-.03-.804-.06-1.218-.144-2.046-.562-4.24-1.733-5.446a2.886 2.886 0 0 0-1.077-.616 5.534 5.534 0 0 0-.753-.212A4.071 4.071 0 0 0 8.846 0a3.614 3.614 0 0 1-1.77.558",
    id: "6ium8jo3vm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.668 0C1.954.005.35 1.2.065 2.772c-.073.4-.204 1.51.396 3.8.349 1.327 1.493 2.391 3.207 2.391 1.713 0 2.857-1.062 3.206-2.39.6-2.291.47-3.402.396-3.801C6.986 1.207 5.394.005 3.688 0h-.02z",
    id: "ytgro2wvgp"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.488 13.28)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "0w79efw4ec",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5362jmud2a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.524.804C.314 2.05.054 4.51 0 6.503h2.87v-.051c.2-2.823.83-4.75 1.926-5.89.04-.042.083-.083.128-.121A2.905 2.905 0 0 1 3.741 0c-.636.015-1.75.317-2.217.804",
    fill: "url(#it4f74hj8b)",
    mask: "url(#0w79efw4ec)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.997 5.169)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dl5h8vorqf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lhvim7p7ld"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.055 2.401c-.063.346-.174 1.308.346 3.29v.001a2.77 2.77 0 0 0 1.025 1.53 2.74 2.74 0 0 0 1.753.543 2.963 2.963 0 0 0 1.525-.4 3.98 3.98 0 0 1-.968-1.753c-.457-1.715-.61-3.162-.428-4.15.093-.493.285-.96.564-1.377A3.28 3.28 0 0 0 3.179 0C1.694 0 .305 1.04.055 2.401",
    fill: "url(#sd3xnhqqwe)",
    mask: "url(#dl5h8vorqf)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.853 13.28)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "v6rsvmp16i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zem3ejf29g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.18 0A2.89 2.89 0 0 1 0 .44c.039.035.075.072.111.108C1.215 1.685 1.85 3.617 2.05 6.452v.051h2.872c-.053-2-.33-4.47-1.537-5.711C2.921.304 1.813.015 1.181 0z",
    fill: "url(#c2ndwfq1oh)",
    mask: "url(#v6rsvmp16i)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.62 5.16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hqx7iypyel",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f4xoixcf0j"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.52 0c-.23 0-.46.026-.685.075.281.422.473.897.564 1.396.181.989.038 2.436-.414 4.14A3.982 3.982 0 0 1 0 7.367c.462.268.987.405 1.52.397a2.738 2.738 0 0 0 1.752-.542 2.77 2.77 0 0 0 1.026-1.53c.52-1.983.408-2.945.343-3.29C4.4 1.041 3.01 0 1.525 0H1.52",
    fill: "url(#xqgrhll8ak)",
    mask: "url(#hqx7iypyel)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.026 13.413)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s7bh3vf95o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6ium8jo3vm"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.075.558H6.14A3.615 3.615 0 0 1 4.365 0a4.29 4.29 0 0 0-.743.095 5.754 5.754 0 0 0-.745.21 2.951 2.951 0 0 0-1.099.633C.618 2.155.203 4.33.058 6.368.03 6.784.012 7.196 0 7.588h13.212c0-.392-.03-.804-.06-1.218-.144-2.046-.562-4.24-1.733-5.446a2.886 2.886 0 0 0-1.077-.616 5.534 5.534 0 0 0-.753-.212A4.071 4.071 0 0 0 8.846 0a3.614 3.614 0 0 1-1.77.558",
    fill: "url(#1afkcah0xn)",
    mask: "url(#s7bh3vf95o)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.964 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9of0xrwklr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ytgro2wvgp"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.668 0C1.954.005.35 1.2.065 2.772c-.073.4-.204 1.51.396 3.8.349 1.327 1.493 2.391 3.207 2.391 1.713 0 2.857-1.062 3.206-2.39.6-2.291.47-3.402.396-3.801C6.986 1.207 5.394.005 3.688 0h-.02z",
    fill: "url(#j964643ztq)",
    mask: "url(#9of0xrwklr)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsStatsSection);
export default __webpack_public_path__ + "static/media/groups-stats-section.2b109929.svg";
export { ForwardRef as ReactComponent };